import Fuse from 'fuse.js'
import { debounce } from 'lodash';
class AutocompleteInput {
    private el: HTMLElement;
    private input: any;
    private autocompleteResultEl: any;
    private list: any;
    private fuzeInstance: any;
    private suggestionItems: any;
    private suggestionItemsIndex: number = -1;
    private setSuggestionItemsEventsBinded: any;

    constructor(el: HTMLElement) {
        this.el = el;
        this.input = this.el.querySelector('input');
        this.autocompleteResultEl = this.el.querySelector('[data-autocomplete-results]');
        this.list = JSON.parse((this as any).input.dataset.inputFilter);
        this.setSuggestionItemsEventsBinded = this.setSuggestionItemsEvents.bind(this);

        this.init();
        this.setEvents();
    }

    private init() {
        this.fuzeInstance = new Fuse(this.list, {
            threshold: 0.2,
        });

        this.input.setAttribute('autocomplete', 'off');
    }

    private setEvents() {
        this.input.addEventListener('input', debounce(this.autcomplete.bind(this), 150));

        this.input.addEventListener('focusout', () => {
            setTimeout(() => {
                if (!(document as any).activeElement.closest('[data-autocomplete]')) {
                    this.clearAutocomplete();
                }
            }, 50);
        });

        this.el.addEventListener('click', (e: any) => {
            if (e.target.hasAttribute('data-autocomplete-results-item')) {
                this.setAutocomplete(e.target.textContent);
            } else if (e.target === this.input) {
                this.autcomplete();
            }
        });
    }

    private setAutocomplete(value: any) {
        this.input.value = value;
        this.clearAutocomplete();
    }

    private clearAutocomplete() {
        this.autocompleteResultEl.innerHTML = '';
        this.el.removeAttribute('data-has-results');
        this.removeAutocompleteEvents();
    }

    private autcomplete() {
        let values = this.fuzeInstance.search((this as any).input.value).filter((item: any, index: number) => index < 8);
        let results: any[] = [];

        this.clearAutocomplete();
        this.removeAutocompleteEvents();

        if (values.length) {
            this.el.setAttribute('data-has-results', '');

            values.forEach((value: any, index: number) => {
                results = [...results, `<div tabindex="0" data-index="${index}" data-autocomplete-results-item>${value.item}</div>`];
            });

            this.autocompleteResultEl.insertAdjacentHTML('beforeend', results.join(''));
            this.addAutocompleteEvents();
        } else {
            this.el.removeAttribute('data-has-results');
        }
    }

    private addAutocompleteEvents() {
        this.suggestionItems = Array.from(this.el.querySelectorAll('[data-autocomplete-results-item]'));

        document.addEventListener('keydown', this.setSuggestionItemsEventsBinded);
    }

    private removeAutocompleteEvents() {
        this.suggestionItems = [];
        this.suggestionItemsIndex = -1;

        document.removeEventListener('keydown', this.setSuggestionItemsEventsBinded);
    }

    private setSuggestionItemsEvents(e: any) {
        if (['ArrowUp', 'ArrowDown', 'Enter', 'Tab'].includes(e.key)) {
            e.preventDefault();
            if (e.key === 'ArrowUp') {
                this.slideToPrevSuggestionItem();
            } else if (e.key === 'ArrowDown' || e.key === 'Tab') {
                this.slideToNextSuggestionItem();
            } else if (e.key === 'Enter') {
                let selected = this.suggestionItems.find((el: any) => el.classList.contains('is-highlighted'));
                this.setAutocomplete(selected?.textContent);
            }
        }
    }

    private slideToNextSuggestionItem() {
        if (this.suggestionItemsIndex >= this.suggestionItems.length - 1) {
            this.suggestionItemsIndex = 0;
        } else {
            this.suggestionItemsIndex += 1;
        }

        this.setActiveSuggestionItem(this.suggestionItemsIndex);
    }

    private slideToPrevSuggestionItem() {
        if (this.suggestionItemsIndex <= 0) {
            this.suggestionItemsIndex = this.suggestionItems.length - 1;
        } else {
            this.suggestionItemsIndex -= 1;
        }

        this.setActiveSuggestionItem(this.suggestionItemsIndex);
    }

    private setActiveSuggestionItem(id: any) {
        this.suggestionItems.forEach((element: any) => {
            if (Number(element.dataset.index) === id) {
                element.classList.add('is-highlighted');
            } else {
                element.classList.remove('is-highlighted');
            }
        })
    }
}

export default AutocompleteInput;
